import { observer } from 'mobx-react-lite'

import { Drawer, useGlobalCopyStore, useRecurringTransactionsStore } from '../../common'
import { RepeatingType } from '../../core'

import { RecurringTransactionDetails } from './RecurringTransactionDetails'

export const RecurringTransactionDetailsDrawer = observer(() => {
  const { recurring: copy } = useGlobalCopyStore()
  const {
    selectedRecurrence,
    selectedRepeatingTransaction,
    setSelectedRecurrence,
    setSelectedRepeatingTransactionGuid,
  } = useRecurringTransactionsStore()

  const handleClose = () => {
    setSelectedRepeatingTransactionGuid(null)
    setSelectedRecurrence(null)
  }

  return (
    <Drawer
      ariaLabelClose={copy.close_drawer_aria}
      isOpen={!!selectedRepeatingTransaction}
      onClose={handleClose}
      title={
        selectedRepeatingTransaction?.repeating_transaction_type === RepeatingType.Income
          ? copy.income_details
          : copy.expense_details
      }
    >
      {selectedRepeatingTransaction && (
        <RecurringTransactionDetails
          onDeleted={handleClose}
          recurringTransaction={selectedRepeatingTransaction}
          selectedRecurrence={selectedRecurrence}
        />
      )}
    </Drawer>
  )
})
